import {
  DeviceAssociatedWithUnit,
  MaybeAssociatedDevice,
} from '@/types/device';

export const isDeviceAssociated = (
  device: MaybeAssociatedDevice,
): device is DeviceAssociatedWithUnit => device.unit !== undefined;
